import {
  createAsyncThunk,
  createSlice,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";
import RosterPlanService from "@/services/api/rosterplan";
import { handleResponse } from "@/services/axios";
interface Loading {
  leads: boolean
}

interface RosterPlanState {
  leads: any[];
  assignedRosters:any[],
  totalCount: number;
  isFetching: boolean;
  error: string | null;
  crmSetting:any[];
  assignedRostersName:any[];
  loading: Loading;
}

const initialState: RosterPlanState = {
  leads: [],
  assignedRosters:[],
  totalCount: 0,
  isFetching: false,
  error: null,
  crmSetting:[],
  assignedRostersName:[],
  loading: { leads: false },
};

export const getLeadsForRosterPlan = createAsyncThunk(
  "rosterPlan/getLeadsForRosterPlan",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await RosterPlanService.leadsForRosterPlan(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch roster plan leads"
      );
    }
  }
);

export const getLeadsForRosterPlanName = createAsyncThunk(
  "rosterPlan/getLeadsForRosterPlanName",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await RosterPlanService.leadsForRosterPlanName(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch roster plan leads"
      );
    }
  }
);

export const assignedRostersForLead = createAsyncThunk(
  "rosterPlan/getAssignedRostersForLead",
  async (params: any, { rejectWithValue }) => {
    try {
      const response =
        await RosterPlanService.assignedRostersForLead(params);

      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch assigned rosters"
      );
    }
  }
);

export const assignLeadRoster = createAsyncThunk(
  "rosterPlan/assignLeadRoster",
  async (params: any, { rejectWithValue }) => {
    try {
      const response =
        await RosterPlanService.assignLeadRoster(params);

      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch assigned rosters"
      );
    }
  }
);

export const getCrmSetting = createAsyncThunk(
  "rosterPlan/getCrmSetting",
  async (__, { rejectWithValue }) => {
    try {
      const response = await RosterPlanService.getCrmSetting();

      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch CRM settings"
      );
    }
  }
);

const rosterPlanSlice = createSlice({
  name: "rosterPlan",
  initialState,

  reducers: {
    clearRosterPlan: (state) => {
      state.leads = [];
      state.totalCount = 0;
    },
  },

  extraReducers: (builder) => {
 builder.addCase(getLeadsForRosterPlan.pending, (state) => {
      state.loading.leads = true;
    });
    builder.addCase(getLeadsForRosterPlan.fulfilled, (state, action) => {
      state.leads = action.payload?.Leads || [];
      state.loading.leads = false;
      state.totalCount = action.payload?.TotalRecords || 0;
    });
    builder.addCase(getLeadsForRosterPlan.rejected, (state) => {
      state.loading.leads = false;
    });
    
    builder.addCase(getLeadsForRosterPlanName.fulfilled, (state, action) => {
      state.assignedRostersName = action.payload?.Leads || [];
    });
    
    builder.addCase(
      assignedRostersForLead.fulfilled, (state, action) => {
        state.assignedRosters = action.payload;
    });

    builder.addCase(
        getCrmSetting.fulfilled,(state,action) =>{
        state.crmSetting = action.payload;
    });

    builder
      .addMatcher(isPending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addMatcher(isFulfilled, (state) => {
        state.isFetching = false;
      })
      .addMatcher(isRejected, (state, action: any) => {
        state.isFetching = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { clearRosterPlan } = rosterPlanSlice.actions;
export default rosterPlanSlice.reducer;